export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}

export function formatRelativeTime(iso: string | undefined, locale = 'en-US'): string {
  if (!iso) return '';
  try {
    const ts = new Date(iso).getTime();
    const diffSec = Math.round((ts - Date.now()) / 1000);
    const abs = Math.abs(diffSec);
    const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
    if (abs < 60) return rtf.format(diffSec, 'second');
    if (abs < 3600) return rtf.format(Math.round(diffSec / 60), 'minute');
    if (abs < 86400) return rtf.format(Math.round(diffSec / 3600), 'hour');
    return rtf.format(Math.round(diffSec / 86400), 'day');
  } catch {
    return iso;
  }
}

export function domainOf(entityId: string): string {
  const idx = entityId.indexOf('.');
  return idx === -1 ? '' : entityId.slice(0, idx);
}

export function friendlyName(entityId: string, attrs: Record<string, unknown>): string {
  const fn = attrs['friendly_name'];
  if (typeof fn === 'string' && fn.length > 0) return fn;
  const dot = entityId.indexOf('.');
  return (dot === -1 ? entityId : entityId.slice(dot + 1)).replace(/_/g, ' ');
}
